import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router";
import { App } from "./App";
import { ErrorBoundary } from "./components/ErrorBoundary";
import { installErrorReporting, reportError } from "./lib/report";
import { SessionProvider } from "./lib/session";
import { watchSystemTheme } from "./lib/theme";
import { watchForUpdates } from "./lib/update";
import "./styles.css";

installErrorReporting();
watchSystemTheme();

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <ErrorBoundary>
      <BrowserRouter>
        <SessionProvider>
          <App />
        </SessionProvider>
      </BrowserRouter>
    </ErrorBoundary>
  </StrictMode>,
);

// Service worker for offline use and push. A new version waits until the user chooses to reload (see lib/update).
if ("serviceWorker" in navigator && import.meta.env.PROD) {
  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/sw.js")
      .then((reg) => watchForUpdates(reg))
      .catch((err) => reportError("other", err, { what: "service worker registration" }));
  });
}
